// Routing/link constants for route-aware SPDS components.

// LinkTo defaults @activeClass to a bare `active`. SPDS stylesheets are compiled with
// `scopeBehaviour: 'global'`, so an unprefixed class name is global and would collide with any
// future SPDS `.active` styling. Namespace the default instead.
export const ACTIVE_CLASS = 'spds-link-active';

// LinkTo asserts when both @model and @models are supplied. Declaring the constraint on @models
// alone is enough: the forbidden assertion fires whenever both arguments are active, regardless
// of which one the author considered primary.
export const FORBIDS_MODEL = Object.freeze([
  { name: 'model', reason: 'Pass either a single @model or an array of @models, not both' },
]);

export default {
  ACTIVE_CLASS,
  FORBIDS_MODEL,
};
